import { Button } from 'components/ui/button';
import { downloadTranscript } from 'features/transcript/utils/transcriptUtils';
import { ArrowLeft, Copy } from 'lucide-react';
import toast from 'react-hot-toast';

interface TranscriptHeaderProps {
  text: string;
}

const TranscriptHeader = ({ text }: TranscriptHeaderProps) => {
  const handleCopy = () => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        toast.success('Text copied to clipboard!');
      })
      .catch((error) => {
        toast.error('Failed to copy text.');
        console.error('Error copying text:', error);
      });
  };

  const handleBack = () => {
    window.history.back();
  };

  return (
    <header className="border-b rounded-t-lg text-text-primary">
      <div className="pl-2 pr-5">
        <div className="h-14 flex items-center justify-between">
          <div className="flex items-center lg:gap-4">
            <Button variant="ghost" size="icon" onClick={handleBack}>
              <ArrowLeft className="h-4 w-4 text-primary" />
            </Button>
            <h1 className="lg:font-semibold text-sm lg:text-xl">
              Transcript Generator
            </h1>
          </div>

          <div className="hidden lg:flex items-center gap-4 text-primary">
            {/* Copy */}
            <Button variant="ghost" size="icon" onClick={handleCopy}>
              <Copy className="h-4 w-4" />
            </Button>

            {/* Discard */}
            <Button
              variant="customSecondary"
              size="sm"
              className="text-[14px] font-normal bg-secondary"
              onClick={handleBack}
            >
              Discard
            </Button>

            <Button
              variant="customSecondary"
              size="sm"
              className="text-[14px] font-normal bg-secondary"
              onClick={() => downloadTranscript(text)}
            >
              Export
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default TranscriptHeader;
